import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { EMPTY_TEXT, Magnetic } from '@mitchell/react.component.ux';
export const StyledGalleryWrapper = styled(Grid, {
    shouldForwardProp: prop => isPropValid(prop) && prop != 'isSelectModeOn'
}) `
	display: inline-block;
	width: 100%;
	background-color: ${(props) => props.isSelectModeOn ? `${Magnetic.backgroundNeutral03}` : `transparent`};
	${(props) => props.isSelectModeOn ? `transition: background-color 1s linear` : EMPTY_TEXT};
`;
export const StyledNoAttachments = styled('div') `
	left: 0;
	top: 0;
	height: 3.43rem;
	background-color: ${Magnetic.colorNeutral5};
	box-sizing: ${Magnetic.formControlCoreBoxSizing};
	border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorNeutral30};
	border-left: 0;
	border-right: 0;
	border-radius: 0;
	box-shadow: none;
	font-size: ${Magnetic.fontSize16};
	color: ${Magnetic.colorNeutral50};
	padding: ${Magnetic.spacer08};
	padding-bottom: ${Magnetic.spacer48};
	text-align: center;
`;
//# sourceMappingURL=GalleryContainer.style.js.map